module.exports = __webpack_public_path__ + "static/media/tax_active_icon.439a1d9f.svg";